import { CarbonEmissionsOrganizationResponse } from "Api/carbonEmissions/carbonEmissions.types";

export type NormalizedCarbonEmissionsData = {
  organizationId: string;
  rawData: CarbonEmissionsOrganizationResponse;
};

// Just store data with minimal transformation
export const normalizeCarbonEmissionsData = (
  data: CarbonEmissionsOrganizationResponse,
  organizationId: string
) => {
  return {
    organizationId,
    rawData: data // Store the raw API response
  };
};
